var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMuseums = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Museum-Painting--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Museum Painting Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22 0H2a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h20a2 2 0 0 0 2 -2V2a2 2 0 0 0 -2 -2Zm0 10.5a0.5 0.5 0 0 1 -0.5 0.5h-19a0.5 0.5 0 0 1 -0.5 -0.5v-8a0.5 0.5 0 0 1 0.5 -0.5h19a0.5 0.5 0 0 1 0.5 0.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.54 4.53a0.55 0.55 0 0 0 -0.45 -0.28 0.55 0.55 0 0 0 -0.48 0.24l-2.4 3.61a0.5 0.5 0 0 1 -0.4 0.24 0.52 0.52 0 0 1 -0.43 -0.15l-1.84 -1.85a0.6 0.6 0 0 0 -0.41 -0.16 0.58 0.58 0 0 0 -0.39 0.19L8.63 8.85a0.55 0.55 0 0 0 0.41 0.9h10.42a0.52 0.52 0 0 0 0.46 -0.27 0.52 0.52 0 0 0 0 -0.54Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 5A1.75 1.75 0 1 0 8 5a1.75 1.75 0 1 0 -3.5 0",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.45 18.92a8 8 0 0 1 -1.75 -1.18 0.27 0.27 0 0 1 -0.07 -0.27 2.13 2.13 0 0 0 0.12 -0.72 2.25 2.25 0 0 0 -4.5 0 2.13 2.13 0 0 0 0.12 0.72 0.27 0.27 0 0 1 -0.07 0.27 8 8 0 0 1 -10.6 0 0.27 0.27 0 0 1 -0.07 -0.27 2.13 2.13 0 0 0 0.12 -0.72 2.25 2.25 0 0 0 -4.5 0 2.13 2.13 0 0 0 0.12 0.72 0.27 0.27 0 0 1 -0.07 0.27 8 8 0 0 1 -1.75 1.18A1 1 0 0 0 1 20.81a1 1 0 0 0 0.45 -0.1 10.16 10.16 0 0 0 1.65 -1 0.27 0.27 0 0 1 0.26 0 0.24 0.24 0 0 1 0.14 0.22V23a1 1 0 0 0 2 0v-3.13a0.24 0.24 0 0 1 0.14 -0.22 0.27 0.27 0 0 1 0.26 0 10 10 0 0 0 12.2 0 0.27 0.27 0 0 1 0.26 0 0.24 0.24 0 0 1 0.14 0.22V23a1 1 0 0 0 2 0v-3.13a0.24 0.24 0 0 1 0.14 -0.22 0.27 0.27 0 0 1 0.26 0 10.16 10.16 0 0 0 1.65 1 1 1 0 0 0 0.45 0.1 1 1 0 0 0 0.45 -1.89Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMuseums);
export default ForwardRef;